"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _react = require('react');



/** The signed-in person's "What's New" status on this device; null while
 * storage is read, and for patients and signed-out users, who never see
 * it. */
 const useWhatsNew = (store, userKey, isPatient) => {
  const key = isPatient ? null : userKey || null
  const status = _react.useSyncExternalStore.call(void 0, 
    store.subscribe,
    () => (key ? store.status(key) : null),
  )
  const open = _react.useCallback.call(void 0, () => { if (key) store.open(key) }, [store, key])
  const dismiss = _react.useCallback.call(void 0, () => { if (key) store.dismiss(key) }, [store, key])
  return { status, open, dismiss }
}; exports.useWhatsNew = useWhatsNew
